// Edge Function client — `seslendirme-gen` çağırır.
// API key burada değil; Supabase Edge Function üzerinden secrets ile erişilir.
// Karia pattern'i 1:1.

import { supabase } from './supabase';

export interface GenerateInput {
  text: string;
  voiceSlug: string;
  meta?: Record<string, unknown>;
}

export interface GenerateOutput {
  url: string;
  bytes: number;
  chars: number;
  history_id: string;
  voice_slug: string;
  estimated_cost_usd: number;
  warning?: string;
  detail?: string;
}

export class GenerateError extends Error {
  constructor(public code: string, public detail?: string) {
    super(`${code}${detail ? `: ${detail}` : ''}`);
  }
}

export async function generateAudio(input: GenerateInput): Promise<GenerateOutput> {
  if (!input.text.trim()) throw new GenerateError('empty_text', 'Metin boş');
  if (!input.voiceSlug.trim()) throw new GenerateError('voice_required', 'Ses seçilmedi');

  const { data, error } = await supabase.functions.invoke<GenerateOutput & { error?: string }>(
    'seslendirme-gen',
    {
      body: {
        text: input.text,
        voice_slug: input.voiceSlug,
        meta: input.meta ?? {},
      },
    },
  );

  if (error) {
    const code = (data as { error?: string } | null)?.error ?? 'invoke_failed';
    const detail = (data as { detail?: string } | null)?.detail ?? error.message;
    throw new GenerateError(code, detail);
  }
  if (!data || !data.url) {
    throw new GenerateError('empty_response', 'Boş yanıt');
  }
  return data;
}

export function estimateCostUsd(chars: number): number {
  return (chars / 1000) * 0.30;
}

export function formatCost(usd: number): string {
  return `$${usd.toFixed(3)}`;
}

// ElevenLabs kalan kredi kotası — SADECE master (elevenlabs-usage Edge Function master-only).
export interface UsageInfo {
  character_count: number;
  character_limit: number;
  remaining: number;
  tier: string | null;
  next_reset_unix: number | null;
}

export async function fetchUsage(): Promise<UsageInfo> {
  const { data, error } = await supabase.functions.invoke<UsageInfo>('elevenlabs-usage');
  if (error || !data) throw new Error(error?.message ?? 'usage_failed');
  return data;
}
